const BOSS_UNAVAILABLE_CONSTANTS = {
  MOVE_BOSS_UNAVAILABLE_ITEMS: 'MOVE_BOSS_UNAVAILABLE_ITEMS',
  FETCH_BOSS_UNAVAILABLE_ITEMS: 'FETCH_BOSS_UNAVAILABLE_ITEMS',
  SET_BOSS_UNAVAILABLE_PRODUCTS: 'SET_BOSS_UNAVAILABLE_PRODUCTS',
  SET_BOSS_UNAVAILABLE_LIST_ID: 'SET_BOSS_UNAVAILABLE_LIST_ID',
  REMOVE_BOSS_UNAVAILABLE_ITEM: 'REMOVE_BOSS_UNAVAILABLE_ITEM',
  FETCH_CONVERTED_BOSS_UNAVAILABLE_ITEM: 'FETCH_CONVERTED_BOSS_UNAVAILABLE_ITEM',
  SET_CONVERTED_BOSS_UNAVAILABLE_ITEM: 'SET_CONVERTED_BOSS_UNAVAILABLE_ITEM',
  SET_REMOVED_BOSS_UNAVAILABLE_ITEM: 'SET_REMOVED_BOSS_UNAVAILABLE_ITEM',
  RESET_BOSS_UNAVAILABLE_STATE_REDUCER: 'RESET_BOSS_UNAVAILABLE_STATE_REDUCER',
  REMOVE_DELETED_ITEM: 'REMOVE_DELETED_ITEM',
  ADD_DELETED_ITEM_ON_API_FAILURE: 'ADD_DELETED_ITEM_ON_API_FAILURE',
  SET_BOSS_UNAVAILABLE_PRODUCTS_IN_LIST: 'SET_BOSS_UNAVAILABLE_PRODUCTS_IN_LIST',
};

export default BOSS_UNAVAILABLE_CONSTANTS;
